import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { StaffLayout } from '../../layouts/StaffLayout';
import { CoachDashboard } from './CoachDashboard';
import { ClientSummaryView } from './ClientSummaryView';
import { ClientDashboardViewLegacy } from './ClientDashboardViewLegacy';
import { CoachCalendarView } from './CoachCalendarView';
import { StaffSettings } from './StaffSettings';

const StaffDashboard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract current view from URL path
  const pathSegments = location.pathname.split('/');
  const currentView = pathSegments[2] || 'dashboard'; // /staff/[view] -> view

  const handleNavigate = (view: string) => {
    navigate(`/staff/${view}`);
  };

  const renderContent = () => {
    switch (currentView) {
      case 'dashboard':
        return (
          <div className="dashboard-content">
            <h1>Staff Dashboard</h1>
            <p>Welcome to the Staff Portal</p>
          </div>
        );
      case 'settings':
        return <StaffSettings />;
      case 'appointments':
      case 'calendar':
        // Handled by dedicated route below
        return null;
      default:
        return (
          <div className="dashboard-content">
            <h1>{currentView}</h1>
            <p>This section is coming soon...</p>
          </div>
        );
    }
  };

  return (
    <StaffLayout currentView={currentView} onNavigate={handleNavigate}>
      <Routes>
        <Route path="/" element={renderContent()} />
        <Route path="/dashboard" element={renderContent()} />
        <Route path="/clients" element={<CoachDashboard />} />
        {/* New Client Summary View (default) */}
        <Route path="/client/:clientId" element={<ClientSummaryView />} />
        {/* All Notes workspace - separate route for URL persistence */}
        <Route path="/client/:clientId/notes" element={<ClientSummaryView />} />
        {/* Goals workspace - separate route for URL persistence */}
        <Route path="/client/:clientId/goals" element={<ClientSummaryView />} />
        {/* Calendar workspace - separate route for URL persistence */}
        <Route path="/client/:clientId/calendar" element={<ClientSummaryView />} />
        {/* Legacy Client Dashboard View (preserved for reference) */}
        <Route path="/client/:clientId/legacy" element={<ClientDashboardViewLegacy />} />
        <Route path="/client/:clientId/legacy/goals" element={<ClientDashboardViewLegacy />} />
        {/* Coach Calendar View - Full calendar with Month/Week/Day views */}
        <Route path="/appointments" element={<CoachCalendarView />} />
        <Route path="/calendar" element={<CoachCalendarView />} />
        <Route path="/settings" element={<StaffSettings />} />
        <Route path="/*" element={renderContent()} />
      </Routes>
      <style>{`
        .dashboard-content {
          padding: 20px;
        }
        .dashboard-content h1 {
          color: var(--text-primary);
          margin-bottom: 16px;
        }
        .dashboard-content p {
          color: var(--text-secondary);
        }
      `}</style>
    </StaffLayout>
  );
};

export default StaffDashboard;